import { Button, Divider, Group, Modal, Text } from "@mantine/core";

interface SubscribeWhilePromotionalConfirmationModalProps {
  openedModal: boolean;
  setOpenedModal: (value: boolean) => void;
  data: any;
  onSubscribe: (lookupKey: string, force?: boolean, extraParams?: any) => void;
}

const SubscribeWhilePromotionalConfirmationModal = ({
  setOpenedModal,
  openedModal,
  data,
  onSubscribe,
}: SubscribeWhilePromotionalConfirmationModalProps) => {
  const { lookupKey } = data;
  return (
    <>
      <Modal
        opened={openedModal}
        onClose={() => setOpenedModal(false)}
        centered
        size="lg"
        title="Subscribe Confirmation"
      >
        <Text>
          You are in a free trial. Would you like to subscribe to a paid plan?
          This will cancel your free trial.
        </Text>
        <Divider my="md" />
        <Group mt="md" justify="flex-start">
          <Button onClick={() => setOpenedModal(false)} variant="default">
            Cancel
          </Button>
          <Button
            onClick={() => {
              setOpenedModal(false);
              onSubscribe(lookupKey, true, { revokePromotion: true });
            }}
          >
            Cancel Free Trial & Subscribe
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default SubscribeWhilePromotionalConfirmationModal;
